import styled from 'styled-components';

// Components
import { ToastShell, ToastText } from '../shared/styles';

// Styles
import { hoverCapable } from '../../../styles/hover';

/**
 * Caja común, en columna: la pregunta arriba y los dos botones debajo.
 *
 * En fila no cabe — la pregunta ocupa dos líneas en tablet vertical y los
 * botones quedarían a menos de la mitad del área de toque mínima.
 */
export const Container = styled(ToastShell)`
  flex-direction: column;
  align-items: stretch;
  gap: 1.2rem;
  border: 1px solid ${({ theme }) => theme.colors.garnet};
  padding: 1.6rem 2rem;
`;

export const Question = styled(ToastText)`
  color: ${({ theme }) => theme.colors.black};
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.2rem;
`;

/**
 * Botón de acción del aviso.
 *
 * 🔴 `min-height: 4.8rem` no es estética: es el objetivo táctil de Material
 * (48 dp) y el AAA de WCAG 2.5.5 (44×44). El mínimo AA (24×24) se queda corto
 * con guantes, que es como se pulsa esto — en marcha y a la intemperie.
 *
 * 🔴 El `:hover` va dentro de `${hoverCapable}` y el resaltado en
 * `:focus-visible`, nunca en `:focus`: en táctil los dos se quedan PEGADOS
 * tras el toque y no se distinguen de «seleccionado». La E2E de escritorio no
 * lo detecta (Chromium cumple el guard), así que esto se pone a mano.
 */
const ActionButton = styled.button`
  flex: 1;
  min-height: 4.8rem;
  padding: 0.8rem 1.6rem;
  border-radius: ${({ theme }) => theme.borderRadius.md};
  cursor: pointer;
  font-family: inherit;
  font-size: 1.6rem;
  font-weight: 600;
  transition: background-color 0.15s ease;

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.garnet};
    outline-offset: 2px;
  }
`;

export const YesButton = styled(ActionButton)`
  border: 1px solid ${({ theme }) => theme.colors.garnet};
  background-color: ${({ theme }) => theme.colors.garnet};
  color: ${({ theme }) => theme.colors.white};

  ${hoverCapable} {
    &:hover:not(:disabled) {
      /* Sin color nuevo en el tema: oscurecer el propio garnet basta y evita
         añadir un token para un solo uso. */
      filter: brightness(0.92);
    }
  }
`;

export const NoButton = styled(ActionButton)`
  border: 1px solid ${({ theme }) => theme.colors.garnet};
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.garnet};

  ${hoverCapable} {
    &:hover:not(:disabled) {
      background-color: ${({ theme }) => theme.colors.garnetClear};
    }
  }
`;
